import styled from 'styled-components';
import { Space } from 'antd';
import { PageContainer } from '../../../../../styles/common.styles';
import { blueDark01, blueLink, grayLight01, white } from '../../../../../styles/colors';

export const NotificationsTabContainer = styled(PageContainer)`
    padding: 24px 0;
    min-width: 1224px;
    padding: 24px 100px 60px 100px;
    position: relative;
`;

export const NotificationsFilterRow = styled(Space)`
    width: 100%;
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const NotificationDayGroupContainer = styled('div')`
    margin-bottom: 8px;
`;

export const NotificationAuthorGroupContainer = styled('div')`
    padding: 4px 0 4px 16px;
`;

export const NotificationToggleRow = styled.div`
    width: 100%;
    padding: 10px 12px;
    padding-left: 0;
    box-sizing: border-box;
    background: ${white};
    border-top: 1px solid ${grayLight01};
`;

export const NotificationToggleButton = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    padding: 0 12px;
    cursor: pointer;
    text-align: left;

    &:focus-visible {
        outline: 2px solid #0071bc;
        outline-offset: 2px;
    }
`;

export const NotificationSwitcherWrap = styled.div`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;

    > div {
        width: 20px !important;
    }

    .switch-container {
        margin-left: 0 !important;
    }
`;

export const NotificationToggleLabel = styled.span`
    font-family: 'Proxima N W15 Bold';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    color: ${blueDark01};
`;

export const NotificationLabel = styled.span`
    display: block;
    font-family: 'Proxima Nova';
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #666666;
`;

export const DayLabel = styled.span<{ open: boolean }>`
    font-family: 'Proxima N W15 Bold';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    color: ${({ open }) => (open ? blueLink : blueDark01)};
`;

export const DayCount = styled.span<{ open: boolean }>`
    font-family: 'Proxima N W15 Bold';
    font-size: 16px;
    color: ${({ open }) => (open ? blueLink : blueDark01)};
    margin-left: 4px;
`;

export const ActivitiesContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 0 8px 0;
    width: 100%;
    margin-left: 170px;
`;

export const ActivityRow = styled.div`
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 14px;
    line-height: 18px;
    padding: 10px 0;
`;

export const ActivityAuthor = styled.span`
    font-family: 'Proxima N W15 Bold';
    font-weight: 400;
    font-size: 13px;
    color: ${blueDark01};
    white-space: nowrap;
    flex-shrink: 0;
`;

export const ActivityText = styled.span`
    font-weight: 400;
    font-size: 14px;
    color: ${blueDark01};
`;

export const ActivityProductLink = styled.a`
    font-weight: 400;
    font-size: 14px;
    color: ${blueLink};
    text-decoration: none;
    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }
`;

export const ActivityRestoreLink = styled.a`
    font-weight: 400;
    font-size: 14px;
    color: ${blueLink};
    text-decoration: none;
    cursor: pointer;
    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }
`;
